import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoadingBarService } from "@ngx-loading-bar/core";

import Swal from "sweetalert2";

import { HeaderService, ServiceOrderService } from "../../../shared";

@Component({
  selector: "app-invoice-view",
  templateUrl: "./invoice-view.component.html",
  styleUrls: ["./invoice-view.component.scss"],
})
export class InvoiceViewComponent implements OnInit {
  title = "ORDEM DE SERVIÇO";
  subtitle = "";
  urlBack = "/panel/invoice/list";

  id;

  serviceOrder;

  returnLink;
  forwardLink;

  total = 0;

  constructor(
    private headerService: HeaderService,
    private serviceOrderService: ServiceOrderService,
    private activatedRoute: ActivatedRoute,
    private loadingBarService: LoadingBarService
  ) {
    if (this.activatedRoute.snapshot.params.id) {
      this.id = this.activatedRoute.snapshot.params.id;

      this.returnLink = `/panel/service-order/return/${this.id}`;
      this.forwardLink = `/panel/service-order/forward/${this.id}`;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle("Visualizar ordem de serviço");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(false);

    this.loadingBarService.start();

    this.serviceOrderService.getServiceOrder(this.id).subscribe((response) => {
      this.serviceOrder = response["data"];

      for (let i = 0; i < this.serviceOrder.items.length; i++) {
        this.total += this.serviceOrder.items[i].vlItem;
      }

      this.loadingBarService.complete();
    });
  }

  forwardServiceOrder() {
    this.loadingBarService.start();

    this.serviceOrderService
      .forwardServiceOrder({ idFsRequisicao: this.id })
      .subscribe((response) => {
        this.loadingBarService.complete();

        Swal({
          type: "success",
          title: "Ordem de serviço",
          text: "Ordem de serviço encaminhado para o prestador selecionado",
          confirmButtonText: "Ok, obrigado!",
          confirmButtonClass: "sweet-button",
          buttonsStyling: false,
        });
      });
  }
}
